import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const DashboardProLayout = lazy(() =>
  import('../components/dashboard-pro/DashboardProLayout').then((m) => ({ default: m.DashboardProLayout }))
)
const DashProHubPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.HubPage }))
)
const DashProScorePage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.ScorePage }))
)
const DashProAlertesPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.AlertesPage }))
)
const DashProCSuitePage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.CSuitePage }))
)
const DashProPanoramaPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.PanoramaPage }))
)
const DashProDrillDownPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.DrillDownPage }))
)
const DashProCorrelationsPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.CorrelationsPage }))
)
const DashProHeatmapPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.HeatmapPage }))
)
const DashProScoreConsolidePage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.ScoreConsolidePage }))
)
const DashProMaturitePage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.MaturiteGlobalePage }))
)
const DashProRisquePage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.RisqueAgregePage }))
)
const DashProConformitePage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.ConformiteUnifieePage }))
)
const DashProRapportCAPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.RapportCAPage }))
)
const DashProTableauCAPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.TableauCAPage }))
)
const DashProKpisPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.KpisPage }))
)
const DashProTendancesPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.TendancesPage }))
)
const DashProMultiSitePage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.MultiSitePage }))
)
const DashProComparaisonPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.ComparaisonPage }))
)
const DashProDeploiementPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.DeploiementPage }))
)
const DashProBenchmarksPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.BenchmarksPage }))
)
const DashProConfigPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.DashProConfigPage }))
)
const DashProIntegrationPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.DashProIntegrationPage }))
)
const DashProAuditTrailPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.DashProAuditTrailPage }))
)
const DashProSettingsPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.DashProSettingsPage }))
)
const DashProOutilsPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.DashProOutilsPage }))
)
const DashProExecutiveBriefingPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.ExecutiveBriefingPage }))
)
const DashProBoardReadinessPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.BoardReadinessPage }))
)
const DashProStrategicRiskRadarPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.StrategicRiskRadarPage }))
)
const DashProDecisionSupportPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.DecisionSupportPage }))
)
const DashProStakeholderMapPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.StakeholderMapPage }))
)
const DashProESGScoreboardPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.ESGScoreboardPage }))
)
const DashProCompetitiveIntelPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.CompetitiveIntelPage }))
)
const DashProKPIAnomalyDashboardPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.KPIAnomalyDashboardPage }))
)
const DashProBoardPackGeneratorPage = lazy(() =>
  import('../pages/dashboard-pro').then((m) => ({ default: m.BoardPackGeneratorPage }))
)

export const dashboardProRoutes: RouteObject[] = [
  {
    path: '/dashboard-pro',
    element: <DashboardProLayout />,
    children: [
      { index: true, element: <DashProHubPage /> },

      { path: 'hub', element: <DashProHubPage /> },
      { path: 'score', element: <DashProScorePage /> },
      { path: 'alertes', element: <DashProAlertesPage /> },
      { path: 'csuite', element: <DashProCSuitePage /> },
      { path: 'panorama', element: <DashProPanoramaPage /> },
      { path: 'drilldown', element: <DashProDrillDownPage /> },
      { path: 'correlations', element: <DashProCorrelationsPage /> },
      { path: 'heatmap', element: <DashProHeatmapPage /> },
      { path: 'score-consolide', element: <DashProScoreConsolidePage /> },
      { path: 'maturite', element: <DashProMaturitePage /> },
      { path: 'risque', element: <DashProRisquePage /> },
      { path: 'conformite', element: <DashProConformitePage /> },
      { path: 'rapport-ca', element: <DashProRapportCAPage /> },
      { path: 'tableau-ca', element: <DashProTableauCAPage /> },
      { path: 'kpis', element: <DashProKpisPage /> },
      { path: 'tendances', element: <DashProTendancesPage /> },
      { path: 'multi-site', element: <DashProMultiSitePage /> },
      { path: 'comparaison', element: <DashProComparaisonPage /> },
      { path: 'deploiement', element: <DashProDeploiementPage /> },
      { path: 'benchmarks', element: <DashProBenchmarksPage /> },
      { path: 'config', element: <DashProConfigPage /> },
      { path: 'integrations', element: <DashProIntegrationPage /> },
      { path: 'audit-trail', element: <DashProAuditTrailPage /> },
      { path: 'settings', element: <DashProSettingsPage /> },
      { path: 'outils', element: <DashProOutilsPage /> },
      { path: 'executive-briefing', element: <DashProExecutiveBriefingPage /> },
      { path: 'board-readiness', element: <DashProBoardReadinessPage /> },
      { path: 'strategic-risk-radar', element: <DashProStrategicRiskRadarPage /> },
      { path: 'decision-support', element: <DashProDecisionSupportPage /> },
      { path: 'stakeholder-map', element: <DashProStakeholderMapPage /> },
      { path: 'esg-scoreboard', element: <DashProESGScoreboardPage /> },
      { path: 'competitive-intel', element: <DashProCompetitiveIntelPage /> },
      { path: 'kpi-anomaly', element: <DashProKPIAnomalyDashboardPage /> },
      // Board Pack Auto (nav-registry) → redirects to the working Board Room surface
      { path: 'board-pack-generator', element: <DashProBoardPackGeneratorPage /> },
    ],
  },
]
